const renderComponent = Component => (state, props) => (
  new Component(state, props)
)

export default renderComponent
